import { render, staticRenderFns } from "./addExp.vue?vue&type=template&id=34504ab0&scoped=true"
import script from "./addExp.vue?vue&type=script&lang=ts"
export * from "./addExp.vue?vue&type=script&lang=ts"
import style0 from "./addExp.vue?vue&type=style&index=0&id=34504ab0&prod&lang=scss"
import style1 from "./addExp.vue?vue&type=style&index=1&id=34504ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34504ab0",
  null
  
)

export default component.exports